import classNames from 'classnames';
import React, { ReactElement } from 'react';

import { IPaginationPagesProps } from './Pagination.interfaces';
import styles from './Pagination.module.css';

export function PaginationPages (props: IPaginationPagesProps): ReactElement {
    const {
        pages,
        currentPage,
        handleChange,
        separator,
        className = '',
        'data-testid': dataTestId = '',
    }: IPaginationPagesProps = props;

    function createClickHandler (page: string): (event: React.MouseEvent<HTMLButtonElement>) => void {
        return (event): void => {
            event.preventDefault();

            if (page === separator) {
                return;
            }

            handleChange(parseInt(page));
        };
    }

    const customClassName: string = classNames({
        [styles.pages]: true,
        [className]: !!className,
    });

    return (
        <div className={customClassName} data-testid={dataTestId}>
            {
                pages.map((page: string, index: number): ReactElement => {
                    const pageClassName: string = classNames({
                        [`cursor-pointer relative outline-none ${styles.page}`]: page !== separator,
                        'cursor-default': page === separator,
                        'text-primary type-subtitle1': page === currentPage.toString(),
                    });

                    return (
                        <button
                            key={`${page}_${index}`}
                            className={pageClassName}
                            onClick={createClickHandler(page)}
                        >
                            {page}
                        </button>
                    );
                })
            }
        </div>
    );
}
